const ListNode = (() => {
    /**
     * Node : LinkedList Node
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    class Node {
        constructor(val, id) {
            this.val = val;
            this.id = id;
            this.next = null
        }
    }
    return {
        Node: Node
    };
})();

/**
 * LinkedList : LinkedList Object
 *
 * @author Nitesh <nitesh.meena@biz2credit.com>
 *
 */
class LinkedList {
    constructor() {
        this.head = null;
        this.size = 0;
        this.map = [];
    }

    /**
     * add : add new object in linkedList
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param val object
     * @param id string
     */
    add(val, id) {
        const node = new ListNode.Node(val, id);
        let current;
        if (this.head === null)
            this.head = node;
        else {
            current = this.head;
            while (current.next) {
                current = current.next;
            }
            current.next = node;
        }
        this.map[this.size] = node;
        this.size++;
    }

    /**
     * insertAt : inserting new object in linkedList at specific given index
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param val object
     * @param id string
     * @param index number
     */
    insertAt(val, id, index) {
        if (index < 0 && index > this.size) return;
        else {
            let node = new ListNode.Node(val, id);
            let curr, prev;
            curr = this.head;
            if (index === 0) {
                node.next = this.head;
                this.head = node;
            } else {
                curr = this.head;
                let it = 0;
                while (it < index) {
                    it++;
                    prev = curr;
                    curr = curr.next;
                }
                node.next = curr;
                prev.next = node;
            }
            this.size++;
        }
    }

    /**
     * getAt : returning target index object from linkedlist
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param index number
     */
    getAt(index) {
        return this.map[index];
    }

    /**
     * removeFrom : removing target index object from linkedlist
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param index number
     */
    removeFrom(index) {
        if (index > 0 && index > this.size)
            return -1;
        else {
            let curr, prev, it = 0;
            curr = this.head;
            prev = curr;

            if (index === 0) {
                this.head = curr.next;
            } else {
                while (it < index) {
                    it++;
                    prev = curr;
                    curr = curr.next;
                }
                prev.next = curr.next;
            }
            this.size--;
            return curr;
        }
    }

    /**
     * isEmpty : checking is linkedlist is empty or not
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    isEmpty() {
        return this.size === 0;
    }

    /**
     * size_of_list : returning linkedlist size
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    size_of_list() {
        return this.size;
    }

    /**
     * getList : returning whole linkedlist array of object
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    getList() {
        let curr = this.head;
        let arr = [];
        while (curr) {
            arr.push(curr);
            curr = curr.next;
        }
        return arr;
    }

    /**
     * searchNodeIndex : returning target index object from updated linkedlist
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     * @param value number
     */
    searchNodeIndexById(value) {
        let curr = this.head;
        let i = 0;
        let index = -1;
        while (curr) {
            if(value == curr.id){ index = i; }
            i++;
            curr = curr.next;
        }
        return index;
    }
}
